import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withApollo } from "react-apollo";
import * as compose from 'lodash.flowright';
import Select from "react-select";

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
          globalBranches{
            id
            branch_name
        }
    }
}

`;

const ADD_LEVEL_EMPLOYEES = gql`
  mutation($params: LevelEmployees) {
    addLevelEmployees(params: $params)
  }
`;

class LeadAndEmployeeCreationModal extends Component {
    constructor() {
        super();
        this.state = {
            branch_id: "",
            branchError: "",
            level_id: "",
            levelError: "",
            head_level_id: "",
            head_levelError: "",
            levelsData: [],
            headLevelsData: [],
            dataClear: 1,
            getEmployeesData: [],
            assignedEmployees: [],
            selectedEmployeData: [],
            loadingSpinner: 0,
            employeeDataSpinner: 0,
            currentStep: 5,
            submitError: "",
        }
    }


    addRow = () => {

        let array = this.state.selectedEmployeData

        array.push({ value: 0, label: "", employee_error: "", assign_employee_error: "Please assigned", is_deleted: false, del_lead_assign_id: 0, is_exist: false })

        this.setState({
            selectedEmployeData: array,
        })

    }

    handleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value


        console.log("name:", name);
        console.log("value:", value);


        if (name == "branch") {
            if (value != "" && value != "--Select Branch--") {
                this.setState({
                    branch_id: value,
                    branchError: "",
                    level_id: "",
                    levelError: "",
                    head_level_id: "",
                    head_levelError: "",
                    headLevelsData: [],
                    dataClear: 1,
                    getEmployeesData: [],
                    selectedEmployeData: [],
                })
                this.getLevelsData();
            } else {
                this.setState({
                    branch_id: "",
                    branchError: "",
                    level_id: "",
                    levelError: "",
                    head_level_id: "",
                    head_levelError: "",
                    headLevelsData: [],
                    dataClear: 1,
                    getEmployeesData: [],
                    selectedEmployeData: [],
                    levelsData: [],
                })
            }
        }
        if (name == "level") {
            if (value != "") {
                this.setState({
                    level_id: value,
                    levelError: "",
                    head_level_id: "",
                    head_levelError: "",
                    dataClear: 1,
                    getEmployeesData: [],
                    selectedEmployeData: [],
                })
                this.getHeadEmployees(value)
            } else {
                this.setState({
                    level_id: "",
                    levelError: "",
                    head_level_id: "",
                    head_levelError: "",
                    dataClear: 1,
                    getEmployeesData: [],
                    selectedEmployeData: [],
                })
            }
        }
        if (name == "levelHead") {
            this.setState({
                head_level_id: value,
                head_levelError: "",
                dataClear: 1,
                getEmployeesData: [],
                selectedEmployeData: [],
            })
        }
    }

    handleGetEmployes = () => {
        if (this.state.branch_id == "" || this.state.branch_id == "--Select Branch--") {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }
        if (this.state.level_id == "" || this.state.level_id == "--Select Level--") {
            this.setState({ levelError: "Please select Level" })
            return ""
        }
        if (this.state.head_level_id == "" || this.state.head_level_id == "--Select LevelHead--") {
            this.setState({ head_levelError: "Please select headLevel" })
            return ""
        }
        this.setState({ currentStep: 1 })
        this.getTotalEmployees();
        this.getLevelEmployees();
    }

    getLevelsData = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($id:Int){
                getLevels(id:$id){
                    level_id
                    level_name
                  }
               }
            `,
            variables: {
                id: 0,
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getLevels.length > 0) {
            let data = result.data.getLevels;
            this.setState({ levelsData: data })
        } else {
            this.setState({ levelsData: [] })
        }
    }

    getHeadEmployees = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int, $level_id:Int){
                getHeadEmployeesDetails(institute_id:$institute_id, branch_id:$branch_id, level_id:$level_id){
                    employee_id
                    employee_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                level_id: parseInt(val) - 1
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getHeadEmployeesDetails.length > 0) {
            let data = result.data.getHeadEmployeesDetails;
            this.setState({ headLevelsData: data })
        } else {
            this.setState({ headLevelsData: [] })
        }
    }

    getTotalEmployees = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int){
                getLeadManagementEmployees(institute_id:$institute_id, branch_id:$branch_id){
                    employee_id
                    employee_name
                    assigned_status
                    emp_mobile
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getLeadManagementEmployees.length > 0) {
            let data = result.data.getLeadManagementEmployees;
            let unAssignedEmp = [];
            let assignedEmp = []
            console.log("unnn", unAssignedEmp);

            if (data.filter((a) => a.assigned_status == "assigned").length > 0) {

                let obj = {
                    label: "Select...",
                    value: 0,
                }
                assignedEmp.push(obj)

                data.filter((a) => a.assigned_status == "assigned").map((item) => {
                    assignedEmp.push({ label: `${item.employee_name}(${item.emp_mobile})`, value: item.employee_id })
                })


            }
            if (data.filter((a) => a.assigned_status == "unassigned").length > 0) {

                let obj = {
                    label: "Select...",
                    value: 0,
                }
                unAssignedEmp.push(obj)

                data.filter((a) => a.assigned_status == "unassigned").map((item) => {
                    unAssignedEmp.push({ label: `${item.employee_name}(${item.emp_mobile})`, value: item.employee_id })
                })

            }

            this.setState({ getEmployeesData: unAssignedEmp, assignedEmployees: assignedEmp })
        } else {
            this.setState({ getEmployeesData: [], assignedEmployees: [] })
        }
    }

    getLevelEmployees = async (val) => {
        this.setState({ selectedEmployeData: [], employeeDataSpinner: 1 })
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int, $head_employee_id:Int){
                getLevelEmployeeDetails(institute_id:$institute_id, branch_id:$branch_id, head_employee_id:$head_employee_id){
                    employee_id
                    employee_name
                    emp_mobile
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                head_employee_id: parseInt(this.state.head_level_id)

            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getLevelEmployeeDetails.length > 0) {
            let data = result.data.getLevelEmployeeDetails;
            let levelEmployees = []
            data.map((item) => {
                let newObj = {
                    value: item.employee_id,
                    label: `${item.employee_name}(${item.emp_mobile})`,
                    is_deleted: false,
                    del_lead_assign_id: 0,
                    is_exist: true,
                    employee_error: "",
                    assign_employee_error: "Please assigned",
                }
                levelEmployees.push(newObj)
            })
            this.setState({ selectedEmployeData: levelEmployees, employeeDataSpinner: 0 })
        } else {
            this.setState({
                selectedEmployeData: [{
                    value: 0,
                    label: "",
                    employee_error: "",
                    is_deleted: false,
                    del_lead_assign_id: 0,
                    is_exist: false,
                    assign_employee_error: "Please assigned",
                }],
                employeeDataSpinner: 0
            })
        }
    }

    handleChange = (e, i) => {



        let val = e.value == undefined ? e.target.value : e.value;
        let name = e.value == undefined ? e.target.name : e.label;
        let array1 = [];



        if (name != "assignEmp") {
            this.state.selectedEmployeData.map((item, index) => {
                if (i == index) {

                    if (val != null || val != 0) {
                        const filteredEmployees = this.state.getEmployeesData.filter((a) => a.value == val);
                        array1.push({ value: `${val}`, label: `${filteredEmployees[0].label}`, is_deleted: false, del_lead_assign_id: 0, is_exist: false })
                    } else {
                        array1.push({ value: 0, label: "Select..." })
                    }
                } else {
                    array1.push({ ...item })
                }

            })

        } else {
            this.state.selectedEmployeData.map((item, index) => {
                if (i == index) {
                    if (val != 0) {
                        array1.push({ ...item, del_lead_assign_id: val, assign_employee_error: "" })
                    } else {
                        array1.push({ ...item, del_lead_assign_id: 0, assign_employee_error: "Please assigned" })

                    }
                } else {
                    array1.push({ ...item })
                }

            })

        }

        this.setState({ selectedEmployeData: array1 })

    }

    handleDelete = (i) => {



        let array1 = [];
        let is_delete = false

        this.state.selectedEmployeData.map((item, index) => {
            if (i == index) {
                if (item.is_exist) {
                    array1.push({ ...item, is_deleted: true })
                } else {
                    is_delete = true
                }
            } else {
                array1.push({ ...item })
            }
        });

        console.log("i", i, is_delete);

        if (is_delete) {
            array1 = array1.filter((item, index) => index != i)
        }



        this.setState({ selectedEmployeData: array1 })

    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch_id: "",
                branchError: "",
                level_id: "",
                levelError: "",
                head_level_id: "",
                head_levelError: "",
                levelsData: [],
                headLevelsData: [],
                dataClear: 1,
                getEmployeesData: [],
                assignedEmployees: [],
                selectedEmployeData: [],
                loadingSpinner: 0,
                employeeDataSpinner: 0,
                currentStep: 5,
                submitError: "",
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    handleSubmit = () => {
        let stopExecuting = false;
        this.state.selectedEmployeData.some((obj, i) => {
            console.log("obj", obj);
            let errorUpdate = this.state.selectedEmployeData

            if (obj.value == null || obj.label == "") {
                errorUpdate[i] = { ...obj, employee_error: "Please select Employee" }
                this.setState({ selectedEmployeData: errorUpdate })
                stopExecuting = true
                return true;
            }
            if (obj.is_deleted === true && obj.del_lead_assign_id == 0) {
                errorUpdate[i] = { ...obj, assign_employee_error: "Please Select" }
                this.setState({ selectedEmployeData: errorUpdate })
                stopExecuting = true
                return true;
            }
        })

        if (stopExecuting) {
            return ""
        }

        const updatedSelectedEmployeData = this.state.selectedEmployeData.map(item => ({
            employee_id: parseInt(item.value),
            is_deleted: item.is_deleted,
            del_lead_assign_id: parseInt(item.del_lead_assign_id),
            is_exist: item.is_exist,
        }));

        console.log("updatedSelectedEmployeData", updatedSelectedEmployeData);

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch_id),
            level_id: parseInt(this.state.level_id),
            head_employee_id: parseInt(this.state.head_level_id),
            inserted_by: parseInt(Cookies.get("id")),
            employeDetails: updatedSelectedEmployeData
        }

        console.log("params", params);

        this.setState({
            loadingSpinner: 1
        });

        this.addLevelEmployees(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
    }

    addLevelEmployees = async (
        params) => {
        await this.props.addLevelEmployees({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addLevelEmployees) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5
                    })
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1000);
                }
            }

        });
    };
    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    render() {
        console.log("stateeeeeeeee", this.state);

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (loading1) return null

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Leads and Employees Creation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} >
                                            <option >--Select Branch--</option>
                                            {this.props.globals.globals.globalBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id} selected={this.state.branch_id == branchdata.id ? true : false}>
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold">Levels</Form.Label>
                                        <Form.Control as="select" name="level" onChange={this.handleInputChange} value={this.state.level_id}>
                                            <option >--Select Level--</option>
                                            {this.state.levelsData.map(leveldata => (
                                                <option key={leveldata.level_id} value={leveldata.level_id} selected={this.state.level_id == leveldata.level_id ? true : false}>
                                                    {leveldata.level_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.levelError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold">Level Head</Form.Label>
                                        <Form.Control as="select" name="levelHead" onChange={this.handleInputChange} value={this.state.head_level_id}>
                                            <option >--Select LevelHead--</option>
                                            {this.state.headLevelsData.map(headdata => (
                                                <option key={headdata.employee_id} value={headdata.employee_id} selected={this.state.head_level_id == headdata.employee_id ? true : false}>
                                                    {headdata.employee_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.head_levelError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch" >
                                        <div className="mt-4">
                                            <Button className="btn btn-success" onClick={this.handleGetEmployes}>Get Employees</Button>
                                        </div>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>
                    {
                        this.state.employeeDataSpinner == 1 ? (
                            <Row className="my-2">
                                <Col>
                                    <div class="spinner-border  text-center loading-img-center"></div>
                                </Col>
                            </Row>
                        ) : ("")
                    }
                    <Row>
                        {
                            this.state.selectedEmployeData.length > 0 ? (this.state.selectedEmployeData.map((item, i) => (
                                <>
                                    <Col lg={6} md={6} sm={6}>
                                        <div className="row">
                                            <Form.Group controlId="SelectClass" style={{ marginLeft: "15px" }}>
                                                <Form.Label className='font-weight-bold fs-5'>Assigned To</Form.Label>
                                                <div className="row">
                                                    <div className="col-md-12 col-sm-12" style={{ width: "200px" }}>
                                                        <Select
                                                            options={this.state.getEmployeesData}
                                                            onChange={(e) => this.handleChange(e, i)}
                                                            name="employee"
                                                            isDisabled={item.is_exist == false ? false : true}
                                                            value={item.value ? { value: item.value, label: item.label } : 0}
                                                        />
                                                    </div>
                                                </div>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    <span className="text-danger">{item.employee_error}</span>
                                                </Form.Text>
                                            </Form.Group>
                                            {
                                                item.is_deleted ? (
                                                    <Form.Group controlId="SelectClass">
                                                        <Form.Label className='font-weight-bold fs-5'>Assign Employee</Form.Label>
                                                        <Form.Control as="select" name="assignEmp" onChange={(e) => this.handleChange(e, i)} style={{ width: "180px" }}>
                                                            {/* <option value="0" >--Select AssignEmp--</option> */}
                                                            {this.state.assignedEmployees.map(data => (
                                                                <option key={data.value} value={data.value} >
                                                                    {data.label}
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text className="form-text text-danger" type="invalid">
                                                            <span className="text-danger">{item.assign_employee_error}</span>
                                                        </Form.Text>
                                                    </Form.Group>
                                                ) : ("")
                                            }
                                            {
                                                !item.is_deleted ? (
                                                    <div className="col-sm-3" style={{ marginLeft: "-13px", marginTop: "27px" }}>
                                                        <button onClick={() => this.handleDelete(i)} className={`btn btn-white text-danger`}
                                                        ><i className="far fa-trash-alt" /></button>
                                                    </div>
                                                ) : ("")

                                            }
                                        </div>
                                    </Col>
                                </>
                            ))) : ("")
                        }

                    </Row >

                    {
                        this.state.selectedEmployeData.length > 0 ? (
                            <div>
                                <button type="button" onClick={this.addRow} className="btn btn-success">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>

                                </button>
                            </div>
                        ) : ("")
                    }
                    {
                        this.state.selectedEmployeData.length > 0 ?
                            <Row>
                                <Col className="text-center">
                                    <Button className="btn btn-success" onClick={this.handleSubmit}>
                                        {
                                            this.state.loadingSpinner == 1 ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : ""
                                        }
                                        Submit</Button>
                                    <div>
                                        {this.state.currentStep == 5 ? (
                                            <p className="text-success">Leads and employees created Successfully</p>
                                        ) : (
                                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                                {this.state.submitError}
                                            </Form.Text>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            : ""
                    }
                </Modal.Body>
            </Modal>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(FETCH_GLOBALS, {
        options: props => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid"))
            }
        }), name: "globals"
    }),
    graphql(ADD_LEVEL_EMPLOYEES, {
        name: "addLevelEmployees"
    }),

)(LeadAndEmployeeCreationModal)));